
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import ProjectUser from '@/views/Authorization/models/projectUser'
import { deleteRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'

@Component({
    name: 'UserDeletePrompt',
    components: { DialogTemplate },
})
export default class UserDeletePrompt extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    url_authorization = process.env.VUE_APP_AUTHORIZATION_BASE_URL
    deleting = false
    confirmationText = ''

    get canDeleteUser() {
        return (
            this.confirmationText ===
            this.$t('fe_authorization.dialog_textConfirmDeleteUser').toString()
        )
    }

    get user(): ProjectUser {
        return this.props.user
    }

    get userName(): string {
        return this.user.userName || this.user.primaryEmail
    }

    get projectName() {
        return this.currentProject.attributes.name
    }

    async deleteUser() {
        if (this.deleting || !this.canDeleteUser) return

        try {
            this.deleting = true
            await deleteRequest(
                getURL({
                    path: `/projectUsers/${this.user._id}`,
                    base: this.url_authorization,
                }),
                {}
            )
            this.$emit('close', true)
        } catch (error) {
            console.error(error)
        } finally {
            this.deleting = false
        }
    }
}
